/** Page-scoped copy and lead intent. The default preserves existing maths pages. */
import { createContext, useContext } from 'react';

import {
  TUITION_SUBJECTS,
  type TuitionSubject,
} from '@shared/tuitionSubjects/tuitionSubjects.js';

const TuitionSubjectContext = createContext<TuitionSubject>('mathematics');
export const TuitionSubjectProvider = TuitionSubjectContext.Provider;

/** Optional page identity; each dialog retains its own CTA placement. */
const TrialSourceContext = createContext<string | null>(null);
export const TrialSourceProvider = TrialSourceContext.Provider;
export function useTrialSourceLocation(placement?: string) {
  const page = useContext(TrialSourceContext);
  return page ? `${page}:${placement ?? 'trial'}` : placement;
}

export function useTuitionSubject() {
  const subject = useContext(TuitionSubjectContext);
  return { subject, ...TUITION_SUBJECTS[subject] };
}
